import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getDeliveryChallan = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/delivery-challan/`);
        return await response.data;
    } catch (error) {
        console.log("getDeliveryChallanLogs - error", error)
        return handleApiError(error)
    }
}

export const getDeliveryChallanById = async (deliveryChallanId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/delivery-challan/${deliveryChallanId}`);
        return await response.data;
    } catch (error) {
        console.log("getDeliveryChallanByIdLogs - error", error)
        return handleApiError(error)
    }
}

export const insertDeliveryChallan = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/delivery-challan/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertDeliveryChallanLogs - error", error)
        return handleApiError(error)
    }
}

export const updateDeliveryChallan = async (deliveryChallanId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/delivery-challan/update/${deliveryChallanId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateDeliveryChallanLogs - error", error)
        return handleApiError(error)
    }
}

export const getDeliveryChallansByDispatchNoteIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/delivery-challan/dispatchNoteIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getDeliveryChallansByDispatchNoteIds - error", error)
        return handleApiError(error)
    }
}

export const getDeliveryChallanByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/delivery-challan/get-delivery-challan-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getDeliveryChallanByDocNo - error", error)
        return handleApiError(error)
    }
}

export const getBulkDeliveryChallanDocs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/delivery-challan/doc-copy`, data);
        return await response.data;
    } catch (error) {
        console.log("getBulkDeliveryChallanDocs - error", error)
    }
}